import {Component, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {BreakpointObserver} from "@angular/cdk/layout";
import {BREAKPOINTS} from "../../../shared/constants/breakpoints";

@Component({
  selector: 'mbnm-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.scss']
})
export class ProductSelectorComponent implements OnChanges {

  constructor(public media: BreakpointObserver) {}

  @Input()
  productCategory:any;

  groupedProducts:any;

  @Output()
  change: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  @Output()
  availableProductsChanged: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  cols = 2;

  @Input('mobile-cols')
  mobileCols = 2;

  @Input()
  selectedProducts: Array<any>;

  @Input()
  noProductsAvailableMessage = 'There are no products matching your criteria.';

  @Input()
  samplesMode = false;

  @Input()
  activeGroupName: string;

  selectedTabIndex = 0;

  ngOnChanges(change) {
    if (change.productCategory) {
      const val = change.productCategory.currentValue;
      this.groupedProducts = this.group(val.filteredProducts ? val.filteredProducts : val.products);
      this.groupedProducts.forEach( (gp, index) => {
        if (val.selection && val.selection.length === 1) {
          if (val.selection[0].shortCategoryName && gp.groupName === val.selection[0].shortCategoryName.toLowerCase().replace(' ', '_')) {
            this.selectedTabIndex = index;
            this.groupedProducts[this.selectedTabIndex].loadContent = true;
          }
        }

        this.groupedProducts[index].hasSaleItems = gp.products.filter(p => p.saleUnitPrice).length > 0;
      });

      this.availableProductsChanged.emit({
        numProductGroups: this.groupedProducts.length,
        allSelected: this.groupedProducts[this.selectedTabIndex].products.length === this.groupedProducts[0].products.filter(p => this.isSelected(p)).length,
        missingDependency: false
      });
    }
  }

  choose(selection:any) {
    if (!this.samplesMode) {
      this.selectedProducts.length = 0;
      this.selectedProducts.push(selection);
    } else {
      const idx = this.selectedProducts.indexOf(selection);
      if (idx > -1) {
        this.selectedProducts.splice(idx, 1);
      } else {
        this.selectedProducts.push(selection);
      }
    }
    this.change.emit(this.selectedProducts);
  }

  tabChanged($event){
    this.selectedTabIndex = $event.index;
    this.groupedProducts[$event.index].loadContent = true;
    this.availableProductsChanged.emit({
      numProductGroups: this.groupedProducts.length,
      allSelected: this.groupedProducts[this.selectedTabIndex].products.length === this.groupedProducts[0].products.filter(p => this.isSelected(p)).length,
      missingDependency: false
    });
  }

  group(data) {
    const noThumb = !this.productCategory.thumbPrefix && !this.productCategory.thumbPostfix && !this.productCategory.groupThumbPostfix;
    if (!this.productCategory.thumbPrefix) {
      this.productCategory.thumbPrefix = '';
    }
    if (!this.productCategory.thumbPostfix) {
      this.productCategory.thumbPostfix = '';
    }
    if (!this.productCategory.groupThumbPostfix) {
      this.productCategory.groupThumbPostfix = this.productCategory.thumbPostfix;
    }

    const grouped = data.reduce((rv, x) => {

      let categoryName = x['shortCategoryName'] ? x['shortCategoryName'] : x['categoryName'];
      if (!categoryName) categoryName = '';
      let el = rv.find((r) => r && r['title'] === categoryName);
      if (!x.thumb) x.thumb = noThumb ? null : this.productCategory.thumbPrefix + x['code'] + this.productCategory.thumbPostfix;

      if (el) {
        el.products.push(x);
      } else {
        rv.push({
          'title': categoryName,
          'groupName': categoryName.trim().replace(/ /g,'_').replace('®','').toLowerCase(),
          'thumb': noThumb ? null : this.productCategory.thumbPrefix + x['code'] + this.productCategory.groupThumbPostfix,
          products: [x]
        });
      }
      return rv;
    }, []);

    if (this.activeGroupName) {
      grouped.sort((x,y) => {
        return x.groupName == this.activeGroupName ? -1 : y.groupName == this.activeGroupName ? 1 : 0;
      });
    }

    return grouped;
  };

  binaryChoices: Array<any> = [
    {
      icon: 'check',
      color: 'green',
      value: true
    },
    {
      icon: 'x',
      color: 'red',
      value: false
    }
  ];

  onOptionValueChange($event) {
    if ($event) {
      this.choose(this.groupedProducts[0].products[0]);
    } else {
      this.choose(null);
    }
  }

  isSelected(product:any): boolean {
    return this.selectedProducts && this.selectedProducts.filter( (selectedProduct) => {
      return selectedProduct.code === product.code;
    }).length === 1;
  }

  public toggleSelectAllForCurrentGroup(selectAll: boolean) {
    // default to currently selected group
    this.groupedProducts[this.selectedTabIndex].products.forEach(product => {
      if (selectAll) {
        if (!this.isSelected(product)) {
          this.choose(product);
        }
      } else {
        if (this.isSelected(product)) {
          this.choose(product);
        }
      }
    })
  }

  public selectAllChanged($event) {
    this.toggleSelectAllForCurrentGroup($event.checked);
  }

  currentGroupSelected(group): boolean {
    for (let i = 0; i < group.length; i++) {
      if (!this.isSelected(group[i])) {
        return false;
      }
    }
    return true;
  }

  protected readonly BREAKPOINTS = BREAKPOINTS;
}
